import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Flex from "../../../../../../components/Flex";
import StyledDialog from "../../../../../../components/StyledDialog";
import Text from "../../../../../../components/Text";
import { DisclosureHost } from "../../../../../../hooks/use-disclosure";
import { formatFieldName } from "../../../../../../utils/utils";

interface ValidationError {
  field: string;
  message: string;
}

interface ClaimValidationErrorsModalProps {
  disclosureHost: DisclosureHost;
  errors?: ValidationError[];
}

const ClaimValidationErrorsModal = ({
  disclosureHost,
  errors,
}: ClaimValidationErrorsModalProps) => {
  const closeModal = () => {
    disclosureHost.close();
  };

  // Use errors from props or from disclosureHost.data
  const validationErrors = errors || disclosureHost.data || [];

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={closeModal}
      dialogTitle="Claim Validation Errors"
      dialogAction={
        <Flex gap={2}>
          <Button variant="contained" color="primary" onClick={closeModal}>
            Close
          </Button>
        </Flex>
      }
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "900px",
          width: "100%",
        },
      }}
    >
      <Box width={"100%"}>
        <Box mb={3}>
          <Text fontSize="1rem" fontWeight={600} mb={1}>
            The following validation errors were found:
          </Text>
          <Text fontSize="0.9rem" color="text.secondary">
            Please fix these errors before submitting the claim.
          </Text>
        </Box>

        {/* Errors Table */}
        <Box>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>No.</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Field Details</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Error Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {validationErrors.length > 0 ? (
                  validationErrors.map(
                    (error: ValidationError, index: number) => (
                      <TableRow key={index} hover>
                        <TableCell>
                          <Text fontSize="0.9rem" fontWeight={500}>
                            {index + 1}
                          </Text>
                        </TableCell>
                        <TableCell>
                          <Text fontSize="0.9rem" fontWeight={500}>
                            {formatFieldName(error.field)}
                          </Text>
                        </TableCell>
                        <TableCell>
                          <Text fontSize="0.9rem">{error.message}</Text>
                        </TableCell>
                      </TableRow>
                    )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <Text fontSize="0.9rem" color="text.secondary">
                        No errors found
                      </Text>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </StyledDialog>
  );
};

export default ClaimValidationErrorsModal;
